/* =========================================================
   KS Custom JavaScript
   Juwelier Kleinschnitz
   update-sicher ausgelagert in assets/ks-custom.js
========================================================= */


/* =========================================================
   1. Neuheiten Slider
   ---------------------------------------------------------
   Funktion:
   - Steuert die Pfeile im Neuheiten-Produkt-Slider.
   - Klick auf linken Pfeil scrollt zurück.
   - Klick auf rechten Pfeil scrollt vor.
   - Scrollweite orientiert sich an der Breite einer Produktkarte.
   ---------------------------------------------------------
   Wird gestartet bei:
   - DOMContentLoaded = normale Seitenladung
   - shopify:section:load = wenn Shopify im Theme-Editor
     eine Section neu lädt
========================================================= */

function initKsNewArrivalsSlider() {
  document.querySelectorAll('.ks-new-arrivals').forEach(function (section) {
    // Verhindert, dass der Slider mehrfach initialisiert wird
    if (section.dataset.ksSliderInit === 'true') return;
    section.dataset.ksSliderInit = 'true';

    const slider = section.querySelector('.ks-new-arrivals__slider');
    const prev = section.querySelector('.ks-slider-prev');
    const next = section.querySelector('.ks-slider-next');

    // Wenn Slider oder Pfeile fehlen, nichts machen
    if (!slider || !prev || !next) return;

    // Berechnet die Scrollweite anhand der ersten Produktkarte plus Abstand
    function getScrollAmount() {
      const item = slider.querySelector('.ks-new-arrivals__item');
      if (!item) return 300;

      const gap = parseFloat(window.getComputedStyle(slider).gap) || 28;
      return item.offsetWidth + gap;
    }

    // Linker Pfeil: vier Produkte zurück
    prev.addEventListener('click', function () {
      slider.scrollBy({
        left: -(getScrollAmount() * 4),
        behavior: 'smooth'
      });
    });

    // Rechter Pfeil: vier Produkte vor
    next.addEventListener('click', function () {
      slider.scrollBy({
        left: getScrollAmount() * 4,
        behavior: 'smooth'
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initKsNewArrivalsSlider);
document.addEventListener('shopify:section:load', initKsNewArrivalsSlider);


/* =========================================================
   2. UVP Tooltip im Neuheiten Slider
   ---------------------------------------------------------
   Funktion:
   - Zeigt bei Klick auf "UVP" eine kleine Erklärung:
     "Unverbindliche Preisempfehlung des Herstellers".
   - Wichtig für Mobile, weil es dort keinen Hover gibt.
   - Verhindert, dass der Klick auf UVP direkt zur Produktseite führt.
   ---------------------------------------------------------
   Wird gestartet bei:
   - DOMContentLoaded
   - shopify:section:load
========================================================= */

function initKsUvpTooltips() {
  document.querySelectorAll('.ks-product-card__uvp').forEach(function (uvp) {
    // Verhindert doppelte EventListener
    if (uvp.dataset.ksUvpInit === 'true') return;
    uvp.dataset.ksUvpInit = 'true';

    // Klick auf UVP öffnet/schließt Tooltip
    uvp.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const wrap = uvp.closest('.ks-product-card__uvp-wrap');
      if (!wrap) return;

      // Andere offene Tooltips schließen
      document.querySelectorAll('.ks-product-card__uvp-wrap.is-active').forEach(function (item) {
        if (item !== wrap) item.classList.remove('is-active');
      });

      // Aktuellen Tooltip umschalten
      wrap.classList.toggle('is-active');
    });

    // Tastaturbedienung: Enter oder Leertaste öffnet Tooltip
    uvp.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      uvp.click();
    });
  });
}

// Klick irgendwo auf der Seite schließt offene UVP-Tooltips
document.addEventListener('click', function () {
  document.querySelectorAll('.ks-product-card__uvp-wrap.is-active').forEach(function (item) {
    item.classList.remove('is-active');
  });
});

document.addEventListener('DOMContentLoaded', initKsUvpTooltips);
document.addEventListener('shopify:section:load', initKsUvpTooltips);


/* =========================================================
   3. Trustbar Mobile Marquee
   ---------------------------------------------------------
   Funktion:
   - Baut die Trustbar auf Mobile zu einem dauerhaften,
     sanften Auto-Slider um.
   - Dafür werden die Trustbar-Items in einen Track verschoben.
   - Anschließend werden die Items dupliziert, damit die Animation
     endlos laufen kann.
   ---------------------------------------------------------
   Hinweis:
   - Die eigentliche Bewegung kommt aus CSS:
     @keyframes ksTrustbarMarquee
   - Dieses Script erstellt nur die nötige Track-Struktur.
   ---------------------------------------------------------
   Wird gestartet bei:
   - DOMContentLoaded
   - shopify:section:load
========================================================= */

function initKsTrustbarMarquee() {
  document.querySelectorAll('.ks-trustbar').forEach(function (trustbar) {
    // Verhindert doppelte Initialisierung
    if (trustbar.dataset.ksMarqueeInit === 'true') return;
    trustbar.dataset.ksMarqueeInit = 'true';

    // Alle originalen Trustbar-Items sammeln
    const items = Array.from(trustbar.children).filter(function (child) {
      return child.classList.contains('ks-trustbar__item');
    });

    if (!items.length) return;

    // Neuen Track erstellen
    const track = document.createElement('div');
    track.className = 'ks-trustbar__track';

    // Original-Items in den Track verschieben
    items.forEach(function (item) {
      track.appendChild(item);
    });

    // Items duplizieren für nahtlose Endlosanimation
    items.forEach(function (item) {
      const clone = item.cloneNode(true);
      clone.classList.add('ks-trustbar__item--clone');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    // Track in Trustbar einsetzen
    trustbar.appendChild(track);
  });
}

document.addEventListener('DOMContentLoaded', initKsTrustbarMarquee);
document.addEventListener('shopify:section:load', initKsTrustbarMarquee);


/* =========================================================
   4. Markenwelt Loop Slider
   ---------------------------------------------------------
   Funktion:
   - Markenlogos laufen dauerhaft in einer sauberen Endlosschleife.
   - Besucher können mit Maus oder Finger ziehen.
   - Nach dem Ziehen läuft der Slider automatisch weiter.
   - Ein normaler Klick auf ein Logo öffnet die Marken-Seite.
========================================================= */

function initKsBrandsLoopSlider() {
  document.querySelectorAll('.ks-brands__marquee').forEach(function (marquee) {
    if (marquee.dataset.ksLoopInit === 'true') return;
    marquee.dataset.ksLoopInit = 'true';

    const track = marquee.querySelector('.ks-brands__track');
    if (!track) return;

    const mobileQuery = window.matchMedia('(max-width: 600px)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    let originalItems = Array.from(track.children).filter(function (item) {
      return !item.hasAttribute('aria-hidden');
    });

    if (!originalItems.length) {
      originalItems = Array.from(track.children);
    }

    const alreadyHasClones = Array.from(track.children).some(function (item) {
      return item.hasAttribute('aria-hidden') || item.dataset.ksBrandClone === 'true';
    });

    if (!alreadyHasClones) {
      originalItems.forEach(function (item) {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.ksBrandClone = 'true';
        track.appendChild(clone);
      });
    }

    marquee.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');
    });

    let offset = 0;
    let loopWidth = 0;
    let lastTime = null;

    let isPointerDown = false;
    let isDragging = false;
    let startX = 0;
    let startOffset = 0;
    let activeLink = null;
    let blockNextClick = false;

    function measureLoopWidth() {
      loopWidth = track.scrollWidth / 2;
      offset = normalizeOffset(offset);
      render();
    }

    function normalizeOffset(value) {
      if (!loopWidth) return value;

      while (value <= -loopWidth) {
        value += loopWidth;
      }

      while (value > 0) {
        value -= loopWidth;
      }

      return value;
    }

    function render() {
      track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
    }

    function getSpeed() {
      return mobileQuery.matches ? 16 : 22;
    }

    function getDragThreshold(event) {
      return event.pointerType === 'touch' ? 14 : 10;
    }

    function animate(time) {
      if (lastTime === null) {
        lastTime = time;
      }

      const delta = Math.min(time - lastTime, 64) / 1000;
      lastTime = time;

      if (!reduceMotion.matches && !isPointerDown && loopWidth > 0) {
        offset = normalizeOffset(offset - getSpeed() * delta);
        render();
      }

      window.requestAnimationFrame(animate);
    }

    marquee.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      isPointerDown = true;
      isDragging = false;
      blockNextClick = false;

      startX = event.clientX;
      startOffset = offset;
      activeLink = event.target.closest('.ks-brand-card');

      marquee.classList.add('is-dragging');

      if (marquee.setPointerCapture) {
        marquee.setPointerCapture(event.pointerId);
      }
    });

    marquee.addEventListener('pointermove', function (event) {
      if (!isPointerDown) return;

      const distance = event.clientX - startX;
      const threshold = getDragThreshold(event);

      if (Math.abs(distance) > threshold) {
        isDragging = true;
        blockNextClick = true;

        offset = normalizeOffset(startOffset + distance);
        render();

        event.preventDefault();
      }
    });

    function stopDragging(event) {
      if (!isPointerDown) return;

      isPointerDown = false;
      marquee.classList.remove('is-dragging');

      if (event && marquee.releasePointerCapture) {
        try {
          marquee.releasePointerCapture(event.pointerId);
        } catch (e) {}
      }

      /* Normaler Klick ohne Drag: Link öffnen */
      if (!isDragging && activeLink && activeLink.href) {
        window.location.href = activeLink.href;
      }

      activeLink = null;
      isDragging = false;

      window.setTimeout(function () {
        blockNextClick = false;
      }, 160);
    }

    marquee.addEventListener('pointerup', stopDragging);
    marquee.addEventListener('pointercancel', stopDragging);
    marquee.addEventListener('lostpointercapture', stopDragging);

    marquee.addEventListener('click', function (event) {
      if (!blockNextClick) return;

      event.preventDefault();
      event.stopPropagation();
    }, true);

    marquee.addEventListener('wheel', function (event) {
      const delta = event.deltaX || (event.shiftKey ? event.deltaY : 0);

      if (!delta) return;

      event.preventDefault();

      offset = normalizeOffset(offset - delta);
      render();
    }, { passive: false });

    window.addEventListener('resize', measureLoopWidth);

    measureLoopWidth();
    window.requestAnimationFrame(animate);
  });
}

document.addEventListener('DOMContentLoaded', initKsBrandsLoopSlider);
document.addEventListener('shopify:section:load', initKsBrandsLoopSlider);


/* =========================================================
   Ende KS Custom JavaScript
========================================================= */


